import { Fragment } from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import useTippy from 'shared/hooks/use-tippy.js';
import SearchPanel from './SearchPanel.jsx';
import tippy_defaults from './tippy-defaults.js';

function SearchMenu({ engine }) {
	const [ref, portal] = useTippy(<SearchPanel loading={ false } engine={ engine } />, {
		...tippy_defaults,
		trigger: 'click',
		appendTo: document.body,
		delay: null,
	});
	
	return (
		<Fragment>
			<span ref={ ref } className="py-2 mx-2 text-base text-white no-underline cursor-pointer font-condensed">
				<Icon icon={ faSearch } className="w-6 h-6" />
			</span>
			{ portal }
		</Fragment>
	);
}

export default SearchMenu;
